import React, { useState } from 'react';
import { Flag, X, AlertTriangle, CheckCircle, ShieldAlert } from 'lucide-react';
import { isRTL } from '../utils/translations';

export default function ReportModal({ isOpen, onClose, targetType = 'SELLER', targetId, targetName }) {
    const rtl = isRTL();
    const [category, setCategory] = useState('SPAM');
    const [details, setDetails] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    if (!isOpen) return null;

    const categories = [
        { id: 'SPAM', labelAr: 'محتوى غير مرغوب فيه (سبام)', labelEn: 'Spam or Advertising' },
        { id: 'FRAUD', labelAr: 'احتيال أو خداع مالي', labelEn: 'Fraud or Scam' },
        { id: 'MISLEADING', labelAr: 'منتج أو وصف مضلل / مقلد', labelEn: 'Misleading / Counterfeit Product' },
        { id: 'HARASSMENT', labelAr: 'إساءة أو مضايقة', labelEn: 'Harassment or Abuse' },
        { id: 'ILLEGAL', labelAr: 'محتوى أو منتج غير قانوني', labelEn: 'Illegal Content / Prohibited Goods' },
        { id: 'OTHER', labelAr: 'أخرى (يرجى التوضيح)', labelEn: 'Other Reason' }
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitting(true);

        const reportRecord = {
            id: 'rep_' + Date.now(),
            targetType,
            targetId,
            targetName,
            category,
            details: details.trim(),
            timestamp: new Date().toISOString(),
            status: 'PENDING_REVIEW'
        };

        try {
            const raw = localStorage.getItem('luxvono_moderation_reports');
            const list = raw ? JSON.parse(raw) : [];
            list.unshift(reportRecord);
            localStorage.setItem('luxvono_moderation_reports', JSON.stringify(list));
        } catch (_) {}

        setTimeout(() => {
            setSubmitting(false);
            setSubmitted(true);
            setTimeout(() => {
                setSubmitted(false);
                setDetails('');
                onClose();
            }, 1800);
        }, 500);
    };

    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.8)', backdropFilter: 'blur(8px)', zIndex: 99999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
            <div style={{ background: '#111827', border: '1px solid #334155', borderRadius: 16, width: '100%', maxWidth: 500, padding: 24, boxShadow: '0 25px 50px rgba(0,0,0,0.7)', color: '#f8fafc' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(239,68,68,0.15)', border: '1px solid #ef4444', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <ShieldAlert size={18} color="#ef4444" />
                        </div>
                        <div>
                            <h3 style={{ margin: 0, fontSize: 16, fontWeight: 800 }}>
                                {rtl ? `إرسال بلاغ أمني: ${targetName || targetType}` : `Report Safety Violation: ${targetName || targetType}`}
                            </h3>
                            <span style={{ fontSize: 11, color: '#94a3b8' }}>
                                {rtl ? 'مراجعة سرية وفورية من فريق الامتثال الأمني' : 'Confidential review by LUXVONO Trust & Safety'}
                            </span>
                        </div>
                    </div>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer' }}>
                        <X size={18} />
                    </button>
                </div>

                {submitted ? (
                    <div style={{ textAlign: 'center', padding: '32px 16px' }}>
                        <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'rgba(16,185,129,0.15)', border: '1px solid #10b981', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
                            <CheckCircle size={28} color="#10b981" />
                        </div>
                        <h4 style={{ fontSize: 16, fontWeight: 700, margin: '0 0 6px 0', color: '#f8fafc' }}>
                            {rtl ? 'تم استلام البلاغ بنجاح' : 'Report Received Successfully'}
                        </h4>
                        <p style={{ margin: 0, fontSize: 12, color: '#94a3b8' }}>
                            {rtl ? 'شكراً لحرصك على أمان وموثوقية منصة LUXVONO. سيتم اتخاذ الإجراء اللازم.' : 'Thank you for protecting the integrity of the LUXVONO marketplace.'}
                        </p>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: 16 }}>
                            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#94a3b8', marginBottom: 8 }}>
                                {rtl ? 'سبب البلاغ' : 'Reason for Report'}
                            </label>
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                                {categories.map(c => (
                                    <label
                                        key={c.id}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 10,
                                            padding: '10px 12px',
                                            background: category === c.id ? 'rgba(37,99,235,0.12)' : '#0b0f19',
                                            border: `1px solid ${category === c.id ? '#3b82f6' : '#1e293b'}`,
                                            borderRadius: 8,
                                            cursor: 'pointer',
                                            fontSize: 13
                                        }}
                                    >
                                        <input
                                            type="radio"
                                            name="reportCategory"
                                            value={c.id}
                                            checked={category === c.id}
                                            onChange={() => setCategory(c.id)}
                                            style={{ accentColor: '#2563eb' }}
                                        />
                                        <span style={{ color: category === c.id ? '#f8fafc' : '#cbd5e1' }}>
                                            {rtl ? c.labelAr : c.labelEn}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div style={{ marginBottom: 20 }}>
                            <label style={{ display: 'block', fontSize: 12, fontWeight: 700, color: '#94a3b8', marginBottom: 6 }}>
                                {rtl ? 'تفاصيل إضافية أو أدلة (اختياري)' : 'Additional Details or Evidence (Optional)'}
                            </label>
                            <textarea
                                value={details}
                                onChange={e => setDetails(e.target.value)}
                                rows={3}
                                placeholder={rtl ? 'وضح سبب المخالفة بمزيد من التفصيل...' : 'Describe the violation in detail...'}
                                style={{ width: '100%', background: '#0b0f19', border: '1px solid #334155', borderRadius: 8, padding: '10px 12px', color: '#fff', fontSize: 13, resize: 'none' }}
                            />
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 10 }}>
                            <button
                                type="button"
                                onClick={onClose}
                                style={{ background: '#1e293b', border: 'none', color: '#94a3b8', padding: '9px 16px', borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: 'pointer' }}
                            >
                                {rtl ? 'إلغاء' : 'Cancel'}
                            </button>
                            <button
                                type="submit"
                                disabled={submitting}
                                style={{ background: 'linear-gradient(135deg, #ef4444, #b91c1c)', border: 'none', color: '#fff', padding: '9px 20px', borderRadius: 8, fontWeight: 700, fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 6 }}
                            >
                                <Flag size={14} />
                                <span>{submitting ? (rtl ? 'جاري الإرسال...' : 'Submitting...') : (rtl ? 'إرسال البلاغ' : 'Submit Report')}</span>
                            </button>
                        </div>
                    </form>
                )}
            </div>
        </div>
    );
}
